<template>
  <div id="index">
    <el-container>
      <el-main class="loginIndex">
        <img src="~assets/img/IRlogo.png" />
        <div class="ReSetPaw" :style="reH">
          <h4 class="title">{{ $t("forgetpws.Forgetthepassword") }}</h4>
          <el-steps :active="active" align-center>
            <el-step
              :title="$t('forgetpws.Fillinemailaddress')"
              :description="$t('forgetpws.FillRightEmail')"
            ></el-step>
            <el-step
              :title="$t('title.resetPassword')"
              :description="$t('forgetpws.CodeReceived')"
            ></el-step>
            <el-step
              :title="$t('forgetpws.complete')"
              :description="$t('forgetpws.Verificationsuccessful')"
            ></el-step>
          </el-steps>
          <el-form ref="formPaw1" :model="formPaw1" label-width="32%">
            <div class="stepDiv" v-show="stepDiv == 1">
              <el-form-item
                :label="$t('forgetpws.accountOrEmail')"
                prop="EmailAddress"
                :rules="[{ required: true, message: $t('tips.needed') }]"
                :error="emailError"
              >
                <el-input
                  type="text"
                  :placeholder="$t('forgetpws.inputEmail')"
                  v-model="formPaw1.EmailAddress"
                  size="small"
                  style="width: 50%; min-width: 200px"
                />
              </el-form-item>

              <el-form-item>
                <el-button
                  type="info"
                  style="margin-top: 12px"
                  v-show="pinfanCount > 0"
                  disabled
                  >{{ $t("forgetpws.next") }} ({{ pinfanCount }})</el-button
                >

                <el-button
                  type="primary"
                  style="margin-top: 12px"
                  v-show="pinfanCount == 0"
                  @click="next"
                  >{{ $t("forgetpws.next") }}
                </el-button>
              </el-form-item>
            </div>
          </el-form>
          <el-form
            ref="formPaw"
            :model="formPaw"
            label-width="32%"
            :rules="rules"
          >
            <div class="stepDiv" v-show="stepDiv == 2">
              <el-form-item :label="$t('title.account')">
                <el-input
                  type="text"
                  v-model="formPaw.EmailAddress"
                  size="small"
                  style="width: 50%; min-width: 200px"
                  disabled
                />
              </el-form-item>
              <el-form-item
                :label="$t('forgetpws.VerificationCode')"
                prop="yzm"
                :error="yzmError"
              >
                <el-input
                  type="text"
                  v-model="formPaw.yzm"
                  size="small"
                  style="width: 120px"
                />
                <el-button
                  type="text"
                  :disabled="reSendBtnDisabled"
                  v-show="reSendCount > 0"
                  style="margin-left: 5px; color: #909399"
                  >{{ $t("forgetpws.ResendCode") }}({{
                    reSendCount
                  }}s)</el-button
                >
                <el-button
                  :loading="loading"
                  type="text"
                  v-show="reSendCount == 0"
                  style="margin-left: 5px"
                  @click="sendEmail('re')"
                  >{{ $t("forgetpws.ResendCode") }}
                </el-button>
                <transition-group name="transtest">
                  <span class="tip" v-if="showTips" :key="1">{{
                    $t("forgetpws.ResendCodeTips")
                  }}</span>
                  <span class="tip" v-if="showTips" :key="2"></span>
                </transition-group>
              </el-form-item>

              <el-form-item :label="$t('title.setNewPwd')" prop="nwepass1">
                <el-input
                  type="password"
                  v-model="formPaw.nwepass1"
                  :placeholder="$t('forgetpws.newpsw')"
                  size="small"
                  style="width: 50%; min-width: 200px"
                  show-password
                />
              </el-form-item>
              <el-form-item :label="$t('forgetpws.newpsw1')" prop="nwepass2">
                <el-input
                  type="password"
                  v-model="formPaw.nwepass2"
                  :placeholder="$t('forgetpws.newpsw3')"
                  size="small"
                  style="width: 50%; min-width: 200px"
                  show-password
                />
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  style="margin-top: 12px"
                  @click="reSetPassword"
                  >{{ $t("forgetpws.confirmbtn") }}</el-button
                >
              </el-form-item>
            </div>
            <div class="stepDiv" v-show="stepDiv == 3">
              <h5 class="finish">
                <i class="el-icon-circle-check"></i>
                <br />
                {{ $t("forgetpws.setclick")
                }}<el-button type="text" @click="backLogin">{{
                  $t("el.pageHeader.title")
                }}</el-button
                >{{ $t("forgetpws.loginAgin") }}(<span>{{ countDown }}s</span>)
              </h5>
            </div>
          </el-form>
        </div>

        <div class="loginRecordBox">
          <el-link href="http://www.irconnectivity.com" target="_blank"
            >备案主体：英格索兰（中国）投资有限公司
          </el-link>
          <el-link href="http://www.beian.miit.gov.cn" target="_blank"
            >备案号：沪ICP备05062828号-5
          </el-link>
          <el-link
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502005741"
            target="_blank"
            ><img
              src="~assets/img/recordicon.png"
              style="float: left; width: 16px"
            />沪公网安备 31010502005741号
          </el-link>
        </div>
      </el-main>
    </el-container>
  </div>
</template>


 
<script type="text/javascript">
import { checkEmailExist, sendVerCode, forgetassword } from "../../api/api";
import { mapState } from "vuex";
export default {
  name: "Index",
  data() {
    var validateyzm = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        return callback(new Error(this.$t("tips.needed")));
      } else {
        callback();
      }
    };
    var validatePass1 = (rule, value, callback) => {
      var yanzheng =
        /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,}$/.test(
          value
        );
      if (value === "") {
        return callback(new Error(this.$t("tips.enterPwd")));
      } else {
        if (!yanzheng) {
          return callback(new Error(this.$t("tips.pwdTips")));
        } else if (this.formPaw.nwepass2 !== "") {
          this.$refs.formPaw.validateField("nwepass2");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      var yanzheng =
        /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,}$/.test(
          value
        );
      if (value === "") {
        return callback(new Error(this.$t("tips.enterAgain")));
      } else if (value !== this.formPaw.nwepass1) {
        return callback(new Error(this.$t("tips.twoPawNotSanme")));
      } else if (!yanzheng) {
        return callback(new Error(this.$t("tips.pwdTips")));
      } else {
        callback();
      }
    };
    return {
      reH: {
        height: "",
      },
      active: 0,
      reSendBtnDisabled: true,
      stepDiv: 1,
      formPaw1: {
        EmailAddress: "",
      },
      formPaw: {
        EmailAddress: "",
        yzm: "",
        nwepass1: "",
        nwepass2: "",
      },
      timers: null,
      countDown: null,
      reSendCount: null,
      pinfanCount: 0,
      yzmError: "",
      emailError: "",
      rules: {
        yzm: [
          //{required:true,message:"不能空",trigger: "blur" },
          { required: true, validator: validateyzm, trigger: "blur" },
        ],
        nwepass1: [
          { required: true, validator: validatePass1, trigger: "blur" },
        ],
        nwepass2: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },
      showTips: true,
      loading: false,
    };
  },

  methods: {
    setHeight() {
      this.reH.height = window.innerHeight - 155 + "px";
    },

    //校验邮箱是否存在,    //下一步发送
    next() {
      this.emailError = "";
      console.log(this.formPaw1.EmailAddress);
      let data = this.formPaw1;
      this.$refs["formPaw1"].validate((valid) => {
        if (valid) {
          checkEmailExist(data)
            .then((res) => {
              if (res.success) {
                if (res.result == "1000003") {
                  this.emailError = this.$t("forgetpws.existEmail");
                } else if (res.result == "1000005") {
                  this.emailError = this.$t("forgetpws.IllegalEmail");
                } else if (res.result == "1000004") {
                  this.emailError = this.$t("forgetpws.frequently");
                  this.pinfan();
                } else {
                  this.stepDiv++;
                  this.active++;
                  this.formPaw = this.formPaw1;
                  if (this.active == 1) {
                    this.reSendEmail();
                  }
                  this.sendEmail("");
                }
              } else {
                this.$message.error(res.error.message);
              }
            })
            .catch((err) => {
              this.$message.error(err.error.message);
            });
        }
      });
    },

    //发送邮件验证码
    sendEmail(re) {
      this.loading = true;
      let data = this.formPaw1;
      sendVerCode(data)
        .then((res) => {
          if (res.success) {
            this.loading = false;
            if (re == "re") {
              this.showTips = true;
              this.reSendEmail();
            }
          } else {
            this.$message.error(res.error.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.error.message);
        });
    },

    //重置密码
    reSetPassword() {
      this.yzmError = "";
      this.$refs["formPaw"].validate((valid) => {
        if (valid) {
          //重置密码校验
          let data = {
            emailAddress: this.formPaw.EmailAddress,
            verifyCode: this.formPaw.yzm,
            password: this.formPaw.nwepass1,
          };
          debugger;
          forgetassword(data).then((res) => {
            if (res.success) {
              if (res.result == "1000001") {
                this.yzmError = this.$t("forgetpws.InvalidCode");
              } else if (res.result == "1000002") {
                this.yzmError = this.$t("forgetpws.expiredCode");
              } else {
                this.stepDiv++;
                this.active++;
                if (this.active == 2) {
                  this.count();
                }
              }
            } else {
              this.$message.error(res.error.message);
            }
          }).catch(err=>{
            this.$message.error(err.error.message);
          });
        }
      });
    },
    backLogin() {
      this.$router.go(-1);
    },
    //返回倒计时
    count() {
      const count = 15;
      this.countDown = count;
      this.timers = setInterval(() => {
        if (this.countDown > 0) {
          this.countDown--;
        } else {
          clearInterval(this.timers);
          debugger;
          this.$router.go(-1);
          //this.$router.push("/clientlogin");
        }
      }, 1000);
    },

    //重发倒计时
    reSendEmail() {
      const count = 60;
      this.reSendCount = count;
      this.timers = setInterval(() => {
        if (this.reSendCount > 0) {
          this.reSendCount--;
          if (this.reSendCount == 55) {
            this.showTips = false;
          }
        } else {
          clearInterval(this.timers);
          this.reSendBtnDisabled = false;
        }
      }, 1000);
    },

    //频繁锁定
    pinfan() {
      const count = 60;
      this.pinfanCount = count;
      this.timers = setInterval(() => {
        if (this.pinfanCount > 0) {
          this.pinfanCount--;
        } else {
          clearInterval(this.timers);
        }
      }, 1000);
    },
  },
  created() {
    window.addEventListener("resize", this.setHeight);

    this.$nextTick(() => {
      var _self = this;
      _self.setHeight();
    });
  },
};
</script>
<style lang='less' scope>
.theme1 {
  .ReSetPaw {
    margin-top: 20px;
  }
  .el-main {
    width: 100%;
  }
  .loginIndex {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-image: url("~assets/img/login.jpg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .loginIndex {
    padding: 20px 7%;
  }

  .transtest-enter,
  .transtest-leave-to {
    opacity: 0;
  }
  .transtest-enter-to,
  .transtest-leave {
    opacity: 1;
  }
  .transtest-enter-active,
  .transtest-leave-active {
    transition: all 3s;
  }
}
</style>